import React, { useEffect, useState } from "react";
import Utils from "../../configs/Utils";
import { Link } from "react-router-dom";
import { Badge, Button } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";

import Tippy from "@tippyjs/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

import "./orderListItem.scss";
import Enums from "../../configs/Enums";


const OrderedListItem = ({ ...props }) => {
  const { id, index, order, store, seller, setOrders, setCountOrders } = props;
  const [qty, setQty] = useState(0);
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [labelVisible, setLabelVisible] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const orderDetailUrl = `/orders/${id}`;

  const handleDeleteOrder = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const label = order.number || order.id;
    if (!window.confirm(`Xoá đơn hàng "${label}" khỏi cơ sở dữ liệu?\nHành động này không thể hoàn tác.`)) {
      return;
    }
    setDeleting(true);
    try {
      const r = await Utils._apiRequest({
        path: Enums.endpoints.orders.DELETE_ONE,
        pathParams: { id },
        type: 'DELETE',
      });
      if (!r?.ok) throw new Error(r?.errors?.message || 'Xoá thất bại');
      if (typeof setOrders === 'function') {
        setOrders((prev) => (prev || []).filter((it) => it._id !== id));
      }
      if (typeof setCountOrders === 'function') {
        setCountOrders((prev) => Math.max(0, (prev || 0) - 1));
      }
      toast.success('Đã xoá đơn hàng');
    } catch (err) {
      toast.error(err.message);
      setDeleting(false);
    }
  };

  const orderRowClickHandle = (e) => {
    // Allow Link default navigation
  }

  const recipient = order.billing || order.recipient_address || {};
  const backgroundColorSeller = Utils.stringToColor(seller.fullName);
  const lineItems = Array.isArray(order.line_items) ? order.line_items : [];
  const itemQty = lineItems.length;
  const firstItem = lineItems[0] || {};
  const thumbUrl =
    firstItem.sku_image ||
    (firstItem.image && firstItem.image.src) ||
    firstItem.thumbnail ||
    '';
  const thumbBg = thumbUrl
    ? `url("${Utils.getMediaImg({ url: thumbUrl, width: 75, height: 75 })}")`
    : 'none';
  const createdAt =
    order.date_created_gmt ||
    order.date_created ||
    order.create_time ||
    order.createdAt;

  useEffect(() => {
    if (order.status === 'AWAITING_SHIPMENT') {
      setLabelVisible(true);
    }
  }, [order]);

  const createShippingLabel = async (e, orderId) => {
    e.preventDefault();
    setIsLoading(true);
    const data = await Utils._apiRequest({
      path: Enums.endpoints.tiktok.CREATE_LABLE,
      payload: {
        orderId: orderId
      },
      type: 'POST'
    });

    setIsLoading(false);
    if (data.message) {
      alert(data.message);
      return;
    }

    console.log('Create label success, please reload this page');
    setLabelVisible(false);
  }

  return (
    <tr className={`table-row orderListItem-row${isLoading ? " loading" : ""}`} data-id={id}>
      <td>{index}</td>
      <td>
        <div className="orderListItem-thumb" style={{
          backgroundImage: thumbBg,
        }}></div>
      </td>
      <td><Link to={orderDetailUrl}>{order.number || order.id}</Link></td>
      <td>{Utils.buildBadgeLable(order.status)}</td>
      <td>{recipient.first_name} {recipient.last_name}</td>
      <td>{itemQty}</td>
      <td>
        {order.total || order.payment?.total_amount} {order.currency || order.payment?.currency}
      </td>
      <td><span className="text-overflow" title={store.storeName}>{store.storeName}</span></td>
      {currentUser?.admin ? <td><Badge bg="custom" style={{ backgroundColor: backgroundColorSeller }} text="Light">{seller?.fullName || 'N/A'}</Badge></td> : <></>}
      <td>{createdAt ? Utils.dateFormat(createdAt) : <span className="text-muted">—</span>}</td>
      <td className="position-relative">
        <div className="d-flex gap-1">
          {labelVisible ? (
            <Tippy content="Create shipping label" theme="light" animation="scale">
              <Button size="sm" variant="warning" onClick={(e) => createShippingLabel(e, id)}>
                <FontAwesomeIcon icon={faTag} />
              </Button>
            </Tippy>
          ) : null}
          <Tippy content="Xoá đơn hàng" theme="light" animation="scale">
            <Button
              size="sm"
              variant="outline-danger"
              onClick={handleDeleteOrder}
              disabled={deleting}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Tippy>
        </div>
      </td>

    </tr>
  );
}

export default OrderedListItem;